import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Icon from "@/components/base/Icon";
import { banners } from "@/mocks/banners";
import { getComicById } from "@/utils/comic";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = banners.length;

  useEffect(() => {
    const timer = setInterval(() => setIndex((i) => (i + 1) % total), 6000);
    return () => clearInterval(timer);
  }, [total]);

  const go = (next: number) => setIndex((next + total) % total);

  return (
    <section className="relative w-full">
      <div className="relative w-full h-[420px] md:h-[600px] overflow-hidden bg-foreground-950">
        {banners.map((banner, i) => {
          const comic = getComicById(banner.comicId);
          return (
            <div
              key={banner.comicId}
              className={`absolute inset-0 transition-opacity duration-700 ${
                i === index ? "opacity-100" : "opacity-0 pointer-events-none"
              }`}
            >
              <img
                src={banner.image}
                alt={`${comic?.title || "漫画"}焦点推荐图`}
                title={`${comic?.title || ""} - 羞羞色漫焦点推荐`}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/20" />
            </div>
          );
        })}

        <div className="absolute inset-0 flex items-center">
          <div className="w-full px-4 md:px-8">
            <div className="max-w-2xl animate-fade-up">
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                <Icon name="ri-fire-fill" className="w-3.5 h-3.5" />
                {banners[index].label}
              </span>
              <h1 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
                {getComicById(banners[index].comicId)?.title}
              </h1>
              <p className="mt-3 text-sm md:text-base text-background-200 max-w-xl leading-relaxed">
                {getComicById(banners[index].comicId)?.description}
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <Link
                  to={`/comic/${banners[index].comicId}`}
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
                >
                  <Icon name="ri-book-open-line" className="w-4 h-4" />
                  查看详情
                </Link>
                <Link
                  to={`/read/${banners[index].comicId}/ch-${getComicById(banners[index].comicId)?.chapterCount || 1}`}
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-50/95 text-foreground-900 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-background-50"
                >
                  <Icon name="ri-play-circle-line" className="w-4 h-4" />
                  开始阅读
                </Link>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          aria-label="上一张"
          onClick={() => go(index - 1)}
          className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 w-10 h-10 items-center justify-center rounded-full bg-background-50/20 text-background-50 backdrop-blur cursor-pointer transition-colors hover:bg-background-50/35"
        >
          <Icon name="ri-arrow-left-s-line" className="w-5 h-5" />
        </button>
        <button
          type="button"
          aria-label="下一张"
          onClick={() => go(index + 1)}
          className="hidden md:flex absolute right-6 top-1/2 -translate-y-1/2 w-10 h-10 items-center justify-center rounded-full bg-background-50/20 text-background-50 backdrop-blur cursor-pointer transition-colors hover:bg-background-50/35"
        >
          <Icon name="ri-arrow-right-s-line" className="w-5 h-5" />
        </button>

        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
          {banners.map((banner, i) => (
            <button
              key={banner.comicId}
              type="button"
              aria-label={`切换到第 ${i + 1} 张`}
              onClick={() => go(i)}
              className={`h-1.5 rounded-full cursor-pointer transition-all duration-300 ${
                i === index ? "w-8 bg-primary-500" : "w-4 bg-background-50/50"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}